var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRecentIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.17641 12.7601C10.1286 12.3782 11.8382 11.0127 12.5682 9.00726C13.6763 5.96265 12.1065 2.59618 9.06188 1.48803L8.27444 1.20108M5.93464 1.24087C3.98249 1.62275 2.27281 2.98832 1.54289 4.99375C0.434745 8.03836 2.00456 11.4048 5.04918 12.513L5.83665 12.7993M5.33574 11.7251L5.83665 12.7993M5.83665 12.7993L4.76246 13.3002M8.77536 2.27527L8.27444 1.20108M8.27444 1.20108L9.34863 0.700195M7.05586 5.32382V6.99999L7.89393 7.83806M10.4077 7.00064C10.4077 8.85207 8.90684 10.3529 7.05541 10.3529C5.20398 10.3529 3.7031 8.85207 3.7031 7.00064C3.7031 5.14921 5.20398 3.64834 7.05541 3.64834C8.90684 3.64834 10.4077 5.14921 10.4077 7.00064Z",
    stroke: "#1B1B1B",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentIcon);
export default __webpack_public_path__ + "static/media/recentIcon.cf409748593aaf41999d587f429ac811.svg";
export { ForwardRef as ReactComponent };